// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "title-4-kk3";
var _3 = "tooltip-3eJpp";
var _4 = "tooltip_arrow-2kKoo";
var _5 = "popper-2TjrG";
export { _1 as "__esModule", _2 as "title", _3 as "tooltip", _4 as "tooltip_arrow", _5 as "popper" }
export default { "__esModule": _1, "title": _2, "tooltip": _3, "tooltip_arrow": _4, "popper": _5 }
